import { ProductDetailData } from "../../../../models/ProductDetailData"

import "./Promotions.css"
import Title from "./components/title/Title"
import NutritionPromo from "./components/promo/NutritionPromo"
import PsychologyPromo from "./components/promo/PsychologyPromo"
import PrivateLoading from "../../loading/PrivateLoading"

type PromotionProps = {
  dietProducts: ProductDetailData[]
  psychologyProducts: ProductDetailData[]
  type: string
  title: string
  subtitle: string
  inCouple: boolean
  date?: string
  discount?: number
  hasOptions?: boolean
  showSubscriptionOptions?: boolean
  showSessionOptions?: boolean
  prominentPromotion?: boolean
  hasBackground?: boolean
  id?: string
}

export default function Promotions({
  dietProducts,
  psychologyProducts,
  date,
  title,
  type,
  subtitle,
  inCouple,
  hasOptions = false,
  showSubscriptionOptions = false,
  showSessionOptions = false,
  discount,
  prominentPromotion = false,
  hasBackground = true,
  id
}: PromotionProps) {
  const products =
    type === "nutrition" ? dietProducts : type === "psychology" ? psychologyProducts : []
  return (
    <div
      id={id}
      className={`bf-promotions-container bf-promotions-container-single ${
        hasBackground ? `bf-${type}-container` : ""
      }`}
    >
      <div className="bf-promotions-content">
        <div className="bf-promotions-title-subcontent">
          <Title
            title={<span dangerouslySetInnerHTML={{ __html: title }} />}
            subtitle={subtitle}
            date={prominentPromotion && !date ? "Superoferta de la semana" : date ? date : "Hoy"}
            isProminent={prominentPromotion}
          />
        </div>
        <div className="bf-promotions-subcontent">
          {products.length > 0 && type === "nutrition" ? (
            <NutritionPromo
              product={products[0]}
              inCouple={inCouple}
              hasOptionsCheck={false}
              showOptions={hasOptions}
              discount={discount}
            />
          ) : products.length > 0 && type === "psychology" ? (
            <PsychologyPromo
              products={products}
              inCouple={inCouple}
              hasOptionsCheck={false}
              showSessionOptions={showSessionOptions}
              showSubscriptionOptions={showSubscriptionOptions}
              discount={discount}
            />
          ) : (
            <div
              style={{
                height: "430px",
                width: "100%",
                backgroundColor: "#f3f3f3",
                position: "relative"
              }}
            >
              <PrivateLoading />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
